import React from "react";

export const MessageChat2 = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.92835 11.2288C6.86619 10.8282 6.83395 10.4179 6.83395 10C6.83395 5.58172 10.4392 2 14.8866 2C19.3339 2 22.9392 5.58172 22.9392 10C22.9392 10.9981 22.7552 11.9535 22.4191 12.8345C22.3493 13.0175 22.3144 13.109 22.2986 13.1804C22.2829 13.2512 22.2768 13.301 22.2751 13.3735C22.2734 13.4466 22.2833 13.5272 22.3032 13.6883L22.7057 16.9585C22.7493 17.3125 22.7711 17.4895 22.7122 17.6182C22.6606 17.731 22.569 17.8205 22.4551 17.8695C22.3251 17.9254 22.1486 17.8995 21.7957 17.8478L18.6104 17.3809C18.4441 17.3565 18.361 17.3443 18.2852 17.3448C18.2103 17.3452 18.1585 17.3507 18.0851 17.3661C18.011 17.3817 17.9163 17.4172 17.727 17.4881C16.8437 17.819 15.8864 18 14.8866 18C14.4684 18 14.0576 17.9683 13.6566 17.9073M8.46556 22C11.4305 22 13.834 19.5376 13.834 16.5C13.834 13.4624 11.4305 11 8.46556 11C5.50067 11 3.09714 13.4624 3.09714 16.5C3.09714 17.1106 3.19426 17.6979 3.37353 18.2467C3.44931 18.4787 3.48721 18.5947 3.49964 18.6739C3.51262 18.7567 3.5149 18.8031 3.51006 18.8867C3.50543 18.9668 3.4854 19.0573 3.44533 19.2383L2.83398 22L5.82879 21.591C5.99225 21.5687 6.07398 21.5575 6.14535 21.558C6.2205 21.5585 6.26039 21.5626 6.33409 21.5773C6.40409 21.5912 6.50814 21.6279 6.71626 21.7014C7.26458 21.8949 7.85309 22 8.46556 22Z"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};